const coursetemplates = {
	title: "Kursmaler",
	stitle: "Kursmal",
	new_coursetemplate: "Ny kursmal",
	edit_coursetemplate: "Rediger kursmal: {name}",
	view_coursetemplate: "Vis kursmal: {name}",
	list_title: "Kursmaler",
	list_subtitle: "Håndtere kursmaler",
	create_title: "Ny kursmal",
	update_title: "Endre kursmal",
	address_title: "Addresse",
	details_title: "Kursmal detaljer",
	id: "ID",
	name: "Navn",
	short_description: "Praktisk info til påmeldingsskjema",
	long_description: "Kompetanse beskrivelse ( vises også i påmelding)",
	certificate_display_name: "Kompetansebevis visningsnavn",
	coursetemplatetype_id: "Type",
	pdf_template: "PDF mal",
	pdf_title: "PDF Tittel",
	pdf_description: "PDF Beskrivelse",
	pdf_content: "PDF Innhold",
	info_link: "Info Link",
	type: "Type",
	price: "Pris",
	price_proof: "Pris for bevis",
	price_vat: "Pris m/MVA",
	valid_for: "Gyldig i",
	status: "Status",
	created_by: "Opprettet av",
	number_of_days: "Antall dager",
	send_email_notification: "Epost varsling",
	send_sms_notification: "SMS varsling",
	duplicate_message: "Vil du opprette en kopi av valgt mal?",
	enrolment_preview: "Forhåndsvisning av påmeldingsskjema",
	internal_comment: "Intern kommentar",
	upload_pdf_template: "Last opp mal",
	select_pdf_template: "Velg PDF",
	preview_pdf_template: "Forhåndsvisning",
	months: "måneder",
	valid_for_helptext: "La denne være tom hvis utløpsdato ikke skal brukes og regnes ut fra utstedelses dato.",
	available_course_templates: "Tilgjengelige maler",
	import_success: "Kursmal(er) er blitt importert",
	import_failed: "Import av kursmal(er) har feilet",
	proceed_template_editing: "Vil du fortsette med redigering av modul mal?",
	module_template_used_multiple: "Modulmal er brukt i følgende kursmaler og endringer vil påvirke alle.",
	updated: "Oppdatert",
	copied_from_admin: "Kopiert fra admin mal den {datetime} av {name}",
	admin_template_from: "Admin mal version er fra den {datetime}",
	admin_version: "Admin version",
	select_template_type: "Vennligst velg mal type ( Kan ikke endres!) ",
	type_normal_helptext: "Kursmal for standard kurs med start og slutt datoer. Denne malen har priselement. Brukes vanligvis av koomersielle kursvirksomheter. F.eks. Til sertifisert opplæring",
	type_long_helptext: "Mal brukes til opplæringsløp uten definert start og slutt dato. Typisk bruk i videregående skole og bedriftsintern opplæring.",
	klarna_checkout: "Klarna Checkout",
	klarna_checkout_type: "Velg Klarna Checkout",
	klarna_checkout_type_helptext: "Velg denne hvis du vil at klarna skal være aktiv som standard for denne malen",
	enrolment_due_in_days: "Påmeldingsfrist",
	enrolment_due_in_days_helptext: "Legg inn antall dager for beregning av påmeldingsfrist.",
};
export default coursetemplates;